import React, { Component } from 'react';
import { Container, Grid, Segment } from 'semantic-ui-react';
// import Home from './components/Home';
// import NoMatch from './components/NoMatch';
import Form from './components/Form';
import GraphPrecise from './components/GraphPrecise';
import GraphAtLeast from './components/GraphAtLeast';
import Chart from './components/Chart';
import Info from './components/Info';
import 'semantic-ui-css/semantic.min.css';
import logo from './logo.png';
import './App.css';

class TopView extends Component {
  render() {
    return (
      <div className="App">
        <div className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h2>Frequency & Reach Calculator</h2>
        </div>

        <Container>
          <Grid columns={2} >
            <Grid.Row columns={1}>
              <Grid.Column>
                <Form />  {/* form  */}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <GraphPrecise /> {/* precise graph  */}
              </Grid.Column>
              <Grid.Column>
                <GraphAtLeast /> {/* 'at least' graph */}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={1}>
              <Grid.Column>
                {/* <Segment color='olive'> */}
                  <Chart />
                {/* </Segment> */}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
        <Container fluid>
          <Grid columns={1}>
            <Grid.Row columns={1}>
              <Grid.Column color='grey'>
                <Info />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </div>
    )
  }
}

export default TopView;



// WEBPACK FOOTER //
// ./src/App.js